import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchExportarLiquidacionesApi } from '../../../../api/axios.js';
import {
    fetchLiquidacionporid,
    fetchLiquidacionporidOrdenes,
    fetchLiquidacionporidNovedades,
    fetchLiquidacionporidLogistica
} from '../../../../actions/LiquidacionesActions';
import DetalleLiquidacionEditar from './DetalleLiquidacionEditar';
import OrdenesDeLiquidacion from './OrdenesDeLiquidacion';
import NovedadesDeLiquidacion from './NovedadesDeLiquidacion';
import LogisticaDeLiquidacion from './LogisticaDeLiquidacion';
import RebatesDeLiquidacion from "./RebatesDeLiquidacion.js";
import GoBackArrow from '../../../General/GoBackArrow';
import MiniSpinner from '../../../General/MiniSpinner';
import LiquidacionToPDF from "./LiquidacionToPDF.js";
import { ExportExcelFile } from "../../../General/Excel/ExcelFileTemplate.js";
import { formatoFechaSinHora } from "../../../../utilities/formatoFecha.js";
import { formatoDecimal } from "../../../../utilities/formatoNumeros.js";
import { toast } from 'react-toastify';


class EditarLiquidacion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hideSpinner: true,
            liquidacion_por_id: [],
            liquidacion_por_id_novedades: [],
            liquidacion_por_id_ordenes: [],
            liquidacion_por_id_logistica: [],
            request: {
                idLiquidacion: parseInt(this.props.match.params.id),
                idSeller: parseInt(this.props.match.params.idSeller),
                borrador: 0
            },
            excelDataSet: []
        }
    };

    componentDidMount() {
        this.props.fetchLiquidacionporid(this.state.request);
        this.props.fetchLiquidacionporidOrdenes(this.state.request);
        this.props.fetchLiquidacionporidNovedades(this.state.request);
        this.props.fetchLiquidacionporidLogistica(this.state.request);
    }

    exportExcel = async () => {
        this.setState({ hideSpinner: false });
        if (this.state.excelDataSet.length < 1) {
            this.fetchDataExcel({ idLiquidacion: this.state.request.idLiquidacion });
        } else {
            this.setState({ hideSpinner: true });
        }
    }

    fetchDataExcel = async (request) => {
        let response;
        try {
            response = await fetchExportarLiquidacionesApi(request);
        } catch (e) {
            toast.error('No se pudo descargar el excel');
            return;
        }
        this.setDataExcel(response);
    }

    setDataExcel = (liquidacionesResponse) => {
        const { idLiquidacion, razonSocialSeller } = this.props.liquidacion_por_id;
        let ordenes = liquidacionesResponse?.ordenes ?? [];
        let novedades = liquidacionesResponse?.novedades ?? [];
        const { rebateConIva, totalOrdenes } = liquidacionesResponse;
        let listaLiquidaciones = [];

        for (let index = 0; index < ordenes.length; index++) {
            var orden = ordenes[index];

            let obj = {
                "Razon Social": razonSocialSeller,
                "Tipo Movimiento": orden?.idAnulacion ? "Anulación" : "Orden",
                "Id Orden": orden.idVenta,
                "Id Anulación": orden?.idAnulacion,
                "SKU Seller": orden?.skuSeller,
                "SKU Market": orden?.skuMarket,
                "Fecha": formatoFechaSinHora(orden?.fecha),
                "Descripción": orden.tipoPublicacion,
                "Monto Operación": formatoDecimal(orden.importe),
                "Comisión Con Iva": formatoDecimal(orden.comisionTotal),
                "Comisión Sin Iva": formatoDecimal(orden.comisionNeto),
                "Peso Hasta": orden.pesoHasta,
                "Peso Aforado": orden.pesoAforado,
                "Envío Gratis": orden.envioGratis ? "Con Envío Gratis" : "Sin Envío Gratis",
                "Código Postal": orden?.codigoPostal,
                "Fee Logístico": formatoDecimal(orden.importeFee),
                "Fee Logístico Sin Iva": formatoDecimal(orden.importeFeeSinIva),
                "Novedades Con Iva": "",
                "Novedades Sin Iva": "",
                "Rebate Con Iva": formatoDecimal(orden.rebateConIva),
                "Rebate Sin Iva": formatoDecimal(orden.rebateSinIva),
                "Rebate Unitario Con Iva": formatoDecimal(orden.rebateUnitario),
                "Neto A Pagar": formatoDecimal(orden.netoAPagar),
                "Total Ordenes": "",
                "Total Rebate Con Iva": ""
            };

            listaLiquidaciones.push(obj);
        }

        for (let index = 0; index < novedades.length; index++) {
            var novedad = novedades[index];

            let dato = {
                "Razon Social": razonSocialSeller,
                "Tipo Movimiento": "Novedad",
                "Id Orden": novedad.idOrden,
                "Id Anulación": "",
                "SKU Seller": "",
                "SKU Market": "",
                "Fecha": formatoFechaSinHora(novedad?.fechaNovedad),
                "Descripción": novedad.descripcion,
                "Monto Operación": "",
                "Comisión Con Iva": "",
                "Comisión Sin Iva": "",
                "Peso Hasta": "",
                "Peso Aforado": "",
                "Envío Gratis": "",
                "Código Postal": "",
                "Fee Logístico": "",
                "Fee Logístico Sin Iva": "",
                "Novedades Con Iva": formatoDecimal(novedad.novedadesConIva),
                "Novedades Sin Iva": formatoDecimal(novedad.novedadesSinIva),
                "Rebate Con Iva": "",
                "Rebate Sin Iva": "",
                "Rebate Unitario Con Iva": "",
                "Neto A Pagar": formatoDecimal(novedad?.importeNovedad),
                "Total Ordenes": "",
                "Total Rebate Con Iva": ""
            };

            listaLiquidaciones.push(dato);
        }

        let footer = {
            "Razon Social": "",
            "Tipo Movimiento": "",
            "Id Orden": "",
            "Id Anulación": "",
            "SKU Seller": "",
            "SKU Market": "",
            "Fecha": "",
            "Descripción": "",
            "Monto Operación": "",
            "Comisión Con Iva": "",
            "Comisión Sin Iva": "",
            "Peso Hasta": "",
            "Peso Aforado": "",
            "Envío Gratis": "",
            "Código Postal": "",
            "Fee Logístico": "",
            "Fee Logístico Sin Iva": "",
            "Novedades Con Iva": "",
            "Novedades Sin Iva": "",
            "Rebate Con Iva": "",
            "Rebate Sin Iva": "",
            "Rebate Unitario Con Iva": "",
            "Neto A Pagar": "",
            "Total Ordenes": totalOrdenes,
            "Total Rebate Con Iva": formatoDecimal(rebateConIva),
        }
        listaLiquidaciones.push(footer);

        if (listaLiquidaciones.length === 0) {
            toast.warn("No se encontraron datos")
            this.setState({ hideSpinner: true });
            return;
        }

        const dataSet = {
            fileResultName: `${razonSocialSeller} Liquidación N° ${idLiquidacion}`,
            sheetName: "Liquidaciones",
            columns: listaLiquidaciones
        };

        this.setState({ hideSpinner: true, excelDataSet: dataSet });
    }

    updateHiddenSpinner = (value) => {
        this.setState({ hideSpinner: !value });
    }


    render() {
        return (
            <div className="container">
                <DetalleLiquidacionEditar
                    liquidacion={this.props.liquidacion_por_id}
                    isBorrador={false}
                />

                <div className="row justify-content-center align-items-center my-4">

                    <div className="col-12 col-sm-auto text-center">
                        <GoBackArrow />
                    </div>

                    <div
                        className="col-1 button-group align-self-center text-right"
                        hidden={this.state.hideSpinner}
                    >
                        <MiniSpinner />
                    </div>

                    <div className="col-auto my-3 my-sm-0">
                        <LiquidacionToPDF
                            request={this.state.request}
                            liquidacion_por_id={this.props.liquidacion_por_id}
                            updateHiddenSpinner={this.updateHiddenSpinner}
                        />
                    </div>

                    <div className="col-auto">
                        <ExportExcelFile dataSet={this.state.excelDataSet} fetchDataExcel={this.exportExcel}>
                            <button
                                className="btn btn-sm background-rojo-megatone"
                                disabled={!this.state.hideSpinner}
                            >
                                Exportar a Excel
                            </button>
                        </ExportExcelFile>
                    </div>

                </div>

                <OrdenesDeLiquidacion
                    ordenes={this.props.liquidacion_por_id_ordenes}
                    isLoading={this.props.isLoadingOrdenes}
                />

                <NovedadesDeLiquidacion
                    novedades={this.props.liquidacion_por_id_novedades}
                    isLoading={this.props.isLoadingNovedades}
                />

                <LogisticaDeLiquidacion
                    logistica={this.props.liquidacion_por_id_logistica}
                    isLoading={this.props.isLoadingLogistica}
                />

                <RebatesDeLiquidacion idLiquidacion={this.state.request.idLiquidacion} />
            </div>
        );
    }
}


const mapStateToProps = state => ({
    isLoadingOrdenes: state.liquidaciones.isLoadingOrdenesLiquidacion,
    isLoadingNovedades: state.liquidaciones.isLoadingNovedadesLiquidacion,
    isLoadingLogistica: state.liquidaciones.isLoadingLogisticaLiquidacion,
    liquidacion_por_id: state.liquidaciones.liquidacion_por_id,
    liquidacion_por_id_novedades: state.liquidaciones.liquidacion_por_id_novedades,
    liquidacion_por_id_ordenes: state.liquidaciones.liquidacion_por_id_ordenes,
    liquidacion_por_id_logistica: state.liquidaciones.liquidacion_por_id_logistica
});

export default connect(mapStateToProps, {
    fetchLiquidacionporid,
    fetchLiquidacionporidOrdenes,
    fetchLiquidacionporidNovedades,
    fetchLiquidacionporidLogistica
})(EditarLiquidacion);